import { render, staticRenderFns } from "./ProcessForm.vue?vue&type=template&id=8289f532&scoped=true"
import script from "./ProcessForm.vue?vue&type=script&lang=js"
export * from "./ProcessForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8289f532",
  null
  
)

export default component.exports